import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { documentsListQueryOptions } from '~bank-documents/service/documentsListQueryOptions'
import { documentListFilterParamsSchema } from '~bank-documents/types/documentList'

export const documentListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    validateSearch: (search) => documentListFilterParamsSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return context.queryClient.getQueryData(['documentsList', deps]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(documentsListQueryOptions(deps))
    },
    component: lazyRouteComponent(() => import('./DocumentList'))
  })
